define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var EngagementsHistory = require('web-agent-assets-js/lpEngagementsHistory');
    var EngagementsHistoryExport = require('web-agent-assets-js/lpEngagementsHistoryExport');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    /**
     * This controller is the base implementation for the engagement history service.
     * It get a controller config from the implementing controller and act upon it's demands
     * @param config
     * @returns an engagement history controller suited to the configuration definitions
     */
    lpTag.lpEngagementHistoryController = function (config) {
        var MAXIMUM_VALUE_IN_SECONDS = 9999999;
        var SECONDS_IN_MINUTE = 60;

        var engagementsHistoryController = {applicationType: config.applicationType || "lpEngagementHistoryController"};
        var engagementHistoryModel = config.model;
        var engagementHistoryPath = config.modelPath || "engagementsHistory";
        var defaultSearchParameters = config.defaultSearchParameters;
        var pollOnTimeIsNow = config.pollOnTimeIsNow;
        var supportOperatorAndSkillNames = typeof config.supportOperatorAndSkillNames !== "undefined" ? config.supportOperatorAndSkillNames : true;
        var agentGroupNameList = {};

        var engagementHistoryApi;
        var engagementHistoryExportApi;
        var receivedOperators = false;
        var receivedSkills = false;
        var requestsObject = {};

        var requestStatuses = {
            FETCHING: "fetching",
            FETCHED: "fetched",
            PUBLISHED: "published",
            ERROR: "error"
        };
        var ExportType = {
            JSON: "json",
            CSV: "csv"
        };

        var logger = WebAgentLogger.getLogger(engagementsHistoryController.applicationType);

        var defaultSearchUIData = {
            limit: defaultSearchParameters.query.limit,
            sortTag: defaultSearchParameters.query.sort.substring(0, defaultSearchParameters.query.sort.indexOf(":")),
            sortOrder: defaultSearchParameters.query.sort.substring(defaultSearchParameters.query.sort.indexOf(":") + 1),
            skip: defaultSearchParameters.query.offset,
            interactive: defaultSearchParameters.body.interactive,
            chatStart: {
                startDate: defaultSearchParameters.body.start.from,
                endDate: defaultSearchParameters.body.start.to
            }
        };
        var startExportNotifier;

        engagementsHistoryController.getDefaultValue = function (valueName) {
            if (valueName) {
                var sValue = valueName.split('.');
                var retVal = defaultSearchUIData;
                while (sValue.length) {
                    retVal = retVal[sValue.shift()];
                }
                return retVal;
            }
        };

        engagementsHistoryController.getModelParam = function (paramName) {
            return engagementHistoryModel.get(paramName);
        };

        engagementsHistoryController.bindModelParam = function (modelParam, func, scope, trigger) {
            engagementHistoryModel.bind(modelParam, func, scope, trigger);
        };

        engagementsHistoryController.unbindModelParam = function (key, callback, context) {
            engagementHistoryModel.unbind(key, callback, context);
        };

        engagementsHistoryController.getSessionData = function (data) {
            return getSessionData(data);
        };

        engagementsHistoryController.saveSessionData = function (data) {
            saveSessionData(data);
        };

        engagementsHistoryController.removeSessionData = function (data) {
            removeSessionData(data);
        };

        engagementsHistoryController.updateQuery = function (searchData) {
            updateQuery(searchData);
            searchEngagements(searchData);
        };
        engagementsHistoryController.exportToJson = function () {
            exportEngagements(ExportType.JSON);
        };
        engagementsHistoryController.exportToCsv = function () {
            exportEngagements(ExportType.CSV);
        };

        engagementsHistoryController.startPolling = function () {
            searchEngagements();
        };

        engagementsHistoryController.stopPolling = function () {
            engagementHistoryApi.stopPolling();
        };

        engagementsHistoryController.modifyEngagementObject = function (engagementObject) {
            modifyEngagementObject(engagementObject);
        };

        /**
         * Search for single engagement
         * @param {string} engagementId
         * @param {Function} success
         * @param {Function} error
         */
        engagementsHistoryController.searchEngagementById = function(engagementId, success, error) {
            var requestObj = {
                success: function(response) {
                    var engagementsArray,
                        engagementsObject;

                if(response && response.body) {
                    if(config.modifyDataCallback) {
                        engagementsArray = dataModelingLinesAndRegister(response.body.interactionHistoryRecords);
                        engagementsObject = config.modifyDataCallback(engagementsArray);
                        if(engagementsObject) {_.keys(engagementsObject).forEach(function(engagementIdSequence){
                                if(engagementIdSequence) {
                            engagementHistoryModel.set(engagementHistoryPath + ".data."+ engagementIdSequence, engagementsObject[engagementIdSequence]);
                                }
                            });
                        }
                    }
                }

                    if(success) {
                        success(engagementsArray, engagementsObject);
                    }
                },
                error: function(data) {
                    if(error) {
                        error(data);
                    }
                },
                query: {},
                data: {engagementId : engagementId}
            };
            engagementHistoryApi.searchEngagements(requestObj, true);
        };

        /**
         * send a request to the service to fetch the data for the conversation.
         * @param {Object} options
         * @param {String} options.visitorId - the visitor id.
         * @param {String} options.chatId - the conversation id
         * @param {String} options.latestAgentId
         * @param {function} options.done - a callback indicating that this operation is done.
         * @param {function} options.error - a callback indicating that this operation was failed.
         */
        engagementsHistoryController.populateChatHistoryConversation = function (options) {
            var conversationId = options.chatId,
                visitorId = options.visitorId,
                done = options.done,
                onError = options.error;

            this.searchEngagementById(conversationId, onSuccess, onError);

            function onSuccess(dataArray){
                if(visitorId) {
                    var engagements = engagementHistoryModel.get(engagementHistoryPath + "." + visitorId + ".array") || [];
                    _.each(engagements, function(engagement){
                        var newEngagement = _.find(dataArray, function(dataObj){
                           return engagement.info.engagementId === dataObj.info.engagementId;
                        });

                        if(newEngagement) {
                            engagement.transcript.line = newEngagement.transcript.line;
                            engagement.data.isPartial = newEngagement.data.isPartial;
                        }
                    });

                }

                done();
            }
        };

        initializeApi();

        function initializeApi() {
            engagementHistoryApi = new EngagementsHistory();
            engagementHistoryExportApi = new EngagementsHistoryExport();

            var savedQuery = getSessionData({name: engagementsHistoryController.applicationType, key: "lastQuery"});
            if (typeof(savedQuery) === "undefined" || savedQuery === null || savedQuery === "") {
                savedQuery = lpUtils.cloneObject(defaultSearchUIData);
            }
            engagementHistoryModel.set(engagementHistoryPath + ".lastQuery", savedQuery);

            if (supportOperatorAndSkillNames) {
                engagementHistoryModel.bind('operators.state', apiStateChanged, this);
                engagementHistoryModel.bind('skills.state', apiStateChanged, this);
            }

            agentGroupNameList = lpTag.WebAgent.logicController.getAgentGroupsById();
        }

        function readyToDisplay() {
            return !supportOperatorAndSkillNames || receivedOperators && receivedSkills;
        }

    function apiStateChanged() {
        if (!readyToDisplay()) {
            var operatorsState, skillsState;
            operatorsState = engagementHistoryModel.get("operators.state");
            skillsState = engagementHistoryModel.get("skills.state");
            receivedOperators = !!operatorsState && !!operatorsState.success;
            receivedSkills = !!skillsState && !!skillsState.success;
            publishPendingResults();
            if (readyToDisplay()) {
                engagementHistoryModel.unbind('operators.state', apiStateChanged, this);
                engagementHistoryModel.unbind('skills.state', apiStateChanged, this);
            }
        }
    }

        /**
         * This method will go over the requestsObject and will write to the model pending results of requests that
         * hasn't been written to the model yet
         * This is needed for requests that returned but we didn't write the result to the model since the operators/skills
         * has yet to return and we couldn't correct the partial data we have for the engagement agent/skill
         */
        function publishPendingResults() {
            for (var key in requestsObject) {
                if (requestsObject.hasOwnProperty(key)) {
                    if (requestsObject[key].status === requestStatuses.FETCHED) {
                        publishEngagementsHistory(requestsObject[key]);
                    }
                }
            }
        }


        function createRequestDataObject() {
            var pollingMethod;
            var queryParams = lpUtils.cloneObject(defaultSearchParameters.query);
            var bodyData = lpUtils.cloneObject(defaultSearchParameters.body);
            var keyword_search_area_type = [];
            // fetching the query data from the model
            var searchData = engagementHistoryModel.get(engagementHistoryPath + ".lastQuery");

            // set's the start date from the defaults if not in the query.
            if (!searchData.hasOwnProperty('chatStart')) {
                searchData.chatStart = lpUtils.cloneObject(defaultSearchUIData.chatStart);
            }

        // starting the adaptation to to server api - creating the query and body data.
        logger.info("", "createRequestDataObject", searchData);
        if (searchData) {
            for (var key in searchData) {
                if (searchData.hasOwnProperty(key)) {
                    switch (key) {
                        case    "limit":
                            queryParams[key] = searchData[key];
                            break;
                        case    "sortTag":
                            queryParams.sort = searchData[key] + ":" + searchData.sortOrder;
                            break;
                        case    "skip":
                            queryParams.offset = searchData[key];
                            break;
                        case    "interactive":
                            bodyData[key] = searchData[key];
                            break;
                        case    "searchTag":
                            if (searchData[key] !== "") {
                                if (searchData.searchArea === "chatId") {
                                    bodyData.engagementId = LE.loginInfo.accountId + searchData[key];
                                } else {
                                    bodyData.keyword = searchData[key];
                                    keyword_search_area_type = keyword_search_area_type.concat(compileSearchListForFilter(searchData.searchArea));
                                }
                            }
                            break;
                        case    "chatStart":
                            if (typeof searchData[key].startDate !== 'undefined') {
                                bodyData.start.from = new Date(searchData[key].startDate).getTime();
                            }
                            if (typeof searchData[key].endDate !== 'undefined') {
                                if (searchData[key].endDate === "Now") {
                                    bodyData.start.to = -1;  // tell the API we want the current time
                                    pollingMethod = pollOnTimeIsNow ? pollingCallback : null;
                                } else {
                                    pollingMethod = undefined;
                                    bodyData.start.to = new Date(searchData[key].endDate).getTime();
                                }
                            }
                            break;
                        case    "skillIds":
                        case    "agentIds":
                            bodyData[key] = (searchData[key]) ? searchData[key].split(",") : null;
                            break;
                        case    "agentGroupIds":
                            bodyData[key] = (searchData[key]) ? searchData[key].split(",") : null;
                            break;
                        case    "duration":
                            var duration = durationFilterDataToApiData(searchData[key]);
                            if (duration) {
                                bodyData.duration = duration;
                            } else if (bodyData.duration) {
                                delete bodyData.duration;
                            }
                            break;
                        case "visitorId":
                            bodyData.visitor = searchData[key];
                            break;
                        case "device":
                            bodyData[key] = searchData[key].status;
                            keyword_search_area_type.push("device");
                            break;
                        case "mcs":
                            switch(searchData[key].status){
                                case "-1":
                                case "1":
                                    bodyData[key] = searchData[key].status;
                                    keyword_search_area_type.push("mcs");
                                    break;
                                case "2":
                                    bodyData.chatMCS ={from: searchData[key].fromMcs, to: searchData[key].toMcs};
                                    //keyword_search_area_type.push("mcs"); // todo: Do we need it here?
                                    break;
                            }
                            break;
                        default :
                            break;
                    }
                }
            }
        }
        if (keyword_search_area_type.length > 0) {
            bodyData.keyword_search_area = {"types": keyword_search_area_type};
        }
        if(bodyData.engagementId) { //when searching on engagementId - we ignore all the other filters
            bodyData = {engagementId: bodyData.engagementId};
        }return {
            queryParams: queryParams,
            bodyData: bodyData,
            pollingMethod: pollingMethod
        };
    }

        function updateQuery(searchData) {
            for (var item in searchData) {
                if (typeof searchData[item] === 'undefined') {
                    engagementHistoryModel.removeKey(engagementHistoryPath + ".lastQuery." + item);
                }
            }

            //engagementHistoryModel.set(engagementHistoryPath + ".lastQuery.searchArea", {}); //delete the last searchArea in preparation for the new one
            engagementHistoryModel.modify(engagementHistoryPath + ".lastQuery", searchData);
            var lastQuery = engagementHistoryModel.get(engagementHistoryPath + ".lastQuery");
            saveSessionData({name: engagementsHistoryController.applicationType, key: "lastQuery", value: lastQuery});
        }

        function pollingCallback(previousRequest) {
            // making sure the request doesn't exceed 31 days into the past
            // if the end time is now
            if (previousRequest && previousRequest.data && previousRequest.data.start) {
                // we make sure the start time is less than 31 days in the past
                var now = new Date().getTime();
                var maxTimeDiffInMilliSeconds = (30 * 24 + 23.5) * 60 * 60 * 1000;
                previousRequest.data.start.to = now;
                if (previousRequest.data.start.from && (now - previousRequest.data.start.from > maxTimeDiffInMilliSeconds)) {
                    previousRequest.data.start.from = now - maxTimeDiffInMilliSeconds;
                }
            }
        }

        /**
         * This method will prepare the request object and will pass to the API layer to perform the request.
         * @param searchData
         */
        function searchEngagements(searchData) {
            var requestData = createRequestDataObject();
            var modelPath = searchData && searchData.engagementHistoryPath || engagementHistoryPath;
            var requestId = Math.random();
            requestsObject[requestId] = { // Mapping this request to a unique key and passing this key to the response callbacks
                requestId: requestId,
                engagementHistoryPath: modelPath,
                status: requestStatuses.FETCHING
            };

            var requestObj = {
                success: lpUtils.callbackContextWrapper(handleSearchSuccess, {requestId: requestId}),
                error: lpUtils.callbackContextWrapper(handleSearchError, {requestId: requestId}),
                query: lpUtils.cloneObject(requestData.queryParams),
                data: lpUtils.cloneObject(requestData.bodyData),
                pollingCallback: requestData.pollingMethod
            };
            engagementHistoryApi.searchEngagements(requestObj);
            engagementHistoryModel.set(modelPath + ".state", {status: requestStatuses.FETCHING});
        }

        function handleSearchSuccess(data) {
            logger.debug("Search return as Success", "handleSearchSuccess");
            if (data && data.body) {
                if (data.body.interactionHistoryRecords) { // Adding to the request data the results of the response.
                    requestsObject[data.context.requestId].status = requestStatuses.FETCHED;
                    requestsObject[data.context.requestId].engagementsCount = data.body._metadata && typeof data.body._metadata.count !== "undefined" ? data.body._metadata.count : null;
                    requestsObject[data.context.requestId].engagementsArray = dataModelingLinesAndRegister(data.body.interactionHistoryRecords);
                    publishEngagementsHistory(requestsObject[data.context.requestId]);
                }
            }
        }

        function dataModelingLinesAndRegister(recordsArray) {
            if (recordsArray && _.isArray(recordsArray)) {
                //for each record
                for (var i = 0; i < recordsArray.length; i++) {

                        if (recordsArray[i] && recordsArray[i].transcript && recordsArray[i].transcript.lines) {
                            var info  = recordsArray[i].info;
                            //for each line
                            for (var j = 0; j < recordsArray[i].transcript.lines.length; j++) {

                                //if it has the "additionalInfo" field, it's a PCI event
                                var line = recordsArray[i].transcript.lines[j];
                                if (line.additionInfo) {

                                    if (line.additionInfo.data.formUniqueId) { //only handle forms that contain uniqueId (forms that don't are from the old event scheme)
                                        line.chatId = info.engagementId.replace(info.accountId,"");
                                        line.args = {
                                            secureFormId: line.additionInfo.data.secureFormId,
                                            secureFormName: line.additionInfo.data.secureFormName,
                                            uniqueId: line.additionInfo.data.formUniqueId
                                        };
                                        line.subType = "leSecureForm"; //they send us "leSecureForm*s* "Secure Form"
                                        if (line.additionInfo.type === "Collaboration") { //legacy
                                            line.isLegacy = true;
                                            line.args.uniqueId = parseInt(line.chatId + line.args.uniqueId, 10); // in legacy the uniqueId is only unique in the scope of the engagement
                                        }
                                        line.visitorId = info.visitorId;
                                        line.type = "leCollaboration"; //they send us "*L*eCollaboration"
                                        line.source = (!!line.source && (line.source !== "") && line.source !== null) ? line.source.toLowerCase() : "visitor"; //they send us "*V*isitor"
                                        line.command = line.additionInfo.data.command;
                                        if (line.additionInfo.data.formUuid) {
                                            line.args.formUuid = line.additionInfo.data.formUuid;
                                        }

                                        delete line.additionInfo;

                                    if (lpTag.WebAgent.logicController.hasSecureFormsFeature() || lpTag.WebAgent.logicController.hasSecureFormsHistoryViewFeature()) {
                                        lpTag.WebAgent.secureFormsController.registerFormSessionInInternalArray(line);
                                    }
                                }
                            }

                    if (line.textType === 'rich-content' && line.text === null) { // Delete text if null for further processing to work correctly
                                delete line.text;
                            }
                        }
                    }
                }
            }
            return recordsArray;
        }

    /**
     * This method will check if we are ready to publish the response data (only if skills/operators API's has returned)
     * If so, it will write to the model to the proper places all the data and will mark the request as "published"
     * @param engagementsHistoryObject
     */
      function publishEngagementsHistory(engagementsHistoryObject) {
        if (config.modifyDataCallback) {
                var engagementsObject = config.modifyDataCallback(engagementsHistoryObject.engagementsArray);
                if (engagementsObject) {
                    engagementHistoryModel.set(engagementsHistoryObject.engagementHistoryPath + ".data", engagementsObject);
                }
            }
            if (engagementsHistoryObject.engagementsCount) {
                engagementHistoryModel.set(engagementsHistoryObject.engagementHistoryPath + ".count", engagementsHistoryObject.engagementsCount);
            }
            engagementHistoryModel.set(engagementsHistoryObject.engagementHistoryPath + ".array", engagementsHistoryObject.engagementsArray);
            engagementHistoryModel.set(engagementsHistoryObject.engagementHistoryPath + ".state", {
                status: requestStatuses.FETCHED,
                success: "ok",
                itemsCount: engagementsHistoryObject.engagementsArray.length
            });
            engagementsHistoryObject.status = requestStatuses.PUBLISHED;
        }


        function handleSearchError(data) {
            logger.error("", "handleSearchError", data);
            logger.graph({name: 'searchHistoryError'});
            engagementHistoryModel.set(data.context.engagementHistoryPath + ".state", {
                status: requestStatuses.ERROR,
                error: (data && data.body && data.body.code) || data || requestStatuses.ERROR
            });
        }

        function createExportRequestDataObject(exportType) {
            var reqDataObj = createRequestDataObject();
            reqDataObj.queryParams.format = exportType;
            reqDataObj.queryParams.lang = LE.localeResolver.getLocale();

            if (reqDataObj.bodyData.start && reqDataObj.bodyData.start.to === -1) {  //the "now" value should be replaced
                reqDataObj.bodyData.start.to = new Date().getTime();
            }
            reqDataObj.queryParams.dtoAsJson = JSON.stringify(reqDataObj.bodyData);

            return reqDataObj;
        }

        /**
         * This method will prepare the request object and will pass to the API layer to perform the request.
         * @param exportType
         */
        function exportEngagements(exportType) {
            //collect current search/filter/sort parameters:
            var reqDataObj = createExportRequestDataObject(exportType);
            startExportNotifier = LE.LEWebAgent.notifier.showInfo(agentLEManager.translateLE("LEWebAgent.ENGAGEMENTS_HISTORY_notify_export_start"));
            var requestId = Math.random();

            var requestObj = {
                success: lpUtils.callbackContextWrapper(function () {
                    logger.debug("Success export of engagement history", "lpEngagementHistoryController:exportEngagements");
                }, {requestId: requestId}),
                error: lpUtils.callbackContextWrapper(function () {
                    logger.debug("exportEngagements error ", "lpEngagementHistoryController:exportEngagements");
                    //need to close the start export notification (if still open) before the error notification can be presented
                    startExportNotifier.close();
                    startExportNotifier = null;

                    LE.LEWebAgent.notifier.showError({
                        content: agentLEManager.translateLE("LEWebAgent.ENGAGEMENTS_HISTORY_notify_export_error"),
                        timeToShow: 6000
                    });

                }, {requestId: requestId}),
                query: lpUtils.cloneObject(reqDataObj.queryParams)
            };

            engagementHistoryExportApi.exportEngagements(requestObj);

        }

        function modifyEngagementObject(engagementObject) {
            var info = engagementObject&& engagementObject.info|| {
            };
            engagementObject.info.agentName = info.agentFullName;
            engagementObject.info.agentNickname = info.agentNickName;
            engagementObject.info.skillName = info.skillName;
            engagementObject.info.visitorName = getVisitorName(engagementObject);
            // Adding the engagementSequence to the engagementId to make sure the id we use is unique (can appear more than once in case the chat was transferred).
            if (typeof engagementObject.info.engagementSequence !== "undefined") {
                engagementObject.info.engagementId += "-" + engagementObject.info.engagementSequence;
            }

            engagementObject.data = {
                isPartial: engagementObject.info.isPartial
            };
        }

        function getVisitorName(engagementObject) {
            if(engagementObject && engagementObject.transcript && engagementObject.transcript.lines){
                for (var i = 0; i < engagementObject.transcript.lines.length; i++) {
                    var chatLine = engagementObject.transcript.lines[i];
                    if (chatLine.source === "visitor" && (typeof chatLine.by === 'string' && chatLine.by.toLowerCase() !== "you")) {
                        return chatLine.by;
                    }
                }
            }
            return 'visitor';
        }

        function getSessionData(data) {
            if (lpTag.WebAgent.WebAgentSessionStorage) {
                return lpTag.WebAgent.WebAgentSessionStorage.getSessionData(engagementsHistoryController.applicationType + '_' + data.name, data.key);
            }
        }

        function saveSessionData(data) {
            if (lpTag.WebAgent.WebAgentSessionStorage) {
                lpTag.WebAgent.WebAgentSessionStorage.setSessionData(engagementsHistoryController.applicationType + '_' + data.name, data.key, data.value);
            }
        }

        function removeSessionData(data) {
            if (lpTag.WebAgent.WebAgentSessionStorage) {
                lpTag.WebAgent.WebAgentSessionStorage.removeSessionData(engagementsHistoryController.applicationType + '_' + data.name, data.key);
            }
        }


        function durationFilterDataToApiData(filterData) {
            var apiData = {};
            if (filterData.comparisonMethod === "longer" && filterData.longerThan === 0) {
                apiData = null;
            } else {
                apiData = {
                    from: filterData.longerThan * SECONDS_IN_MINUTE,
                    to: filterData.shorterThan * SECONDS_IN_MINUTE
                };
                if (filterData.comparisonMethod === "longer") {
                    apiData.to = MAXIMUM_VALUE_IN_SECONDS;
                } else if (filterData.comparisonMethod === "shorter") {
                    apiData.from = 0;
                }
            }
            return apiData;
        }

        //chatId is handles in getItemForEngagementIdSearch
        function compileSearchListForFilter(checkedElements) {
            //check if there is a filter in this request. If there is no filter, just add everything
            var activeFiltering = (checkedElements.length > 0);

            //create a full list to search by. Most of the searches will be without filter
            var listToSearchBy = [];

            //check the selections and pop the non relevant items from the list
            if (_.contains(checkedElements, "transcript") || !activeFiltering) {
                listToSearchBy.push("chatLine");
            }
            if (_.contains(checkedElements, "surveys") || !activeFiltering) {
                listToSearchBy.push("surveyAnswer", "surveyQuestion");
            }
            if (_.contains(checkedElements, "visitorInfo") || !activeFiltering) {
                listToSearchBy.push("visitorInfo");
            }
            if (_.contains(checkedElements, "SDES") || !activeFiltering) {
                listToSearchBy.push(
                    "ea.purchase",
                    "ea.viewedProduct",
                    "ea.cartStatus",
                    "ea.serviceActivity",
                    "ea.visitorError",
                    "ea.lead",
                    "ea.customerInfo",
                    "ea.marketingCampaignInfo",
                    "ea.personalInfo");
            }
            return listToSearchBy;
        }

        return engagementsHistoryController;
    };

    return lpTag.lpEngagementHistoryController;

});
